import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { TituloReceberTableModule } from '../../../view/table';
import { ClientePipeSharedModule } from '../../../../pessoa/cliente/pipes';

import { TituloReceberClienteViewModalComponent } from './titulo-receber-cliente-view-modal.component';

@NgModule({
    imports: [
        SharedModule,
        TituloReceberTableModule,
        ClientePipeSharedModule
    ],
    declarations: [
        TituloReceberClienteViewModalComponent
    ],
    exports: [
        TituloReceberClienteViewModalComponent
    ]
})
export class TituloReceberClienteViewModalModule { }
